import { Button } from "@mui/material";
import appcolors from "../../constants/Colors";

const GlobalButton = ({
  variant,
  handleClickBtn,
  endIcon,
  startIcon,
  disabled,
  hoverProperties,
  iconHoverColor,
  btnText,
  disableRipple,
  styleProps,
}) => {
  return (
    <Button
      disableRipple={false || disableRipple}
      variant={variant || "contained"}
      minWidth="auto"
      whiteSpace="nowrap"
      onClick={handleClickBtn}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled}
      sx={{
        ...styleProps,
        "&:hover": {
          ...hoverProperties,
        },
        "&.MuiButtonBase-root:hover .MuiButton-startIcon svg": {
          color: iconHoverColor,
        },
        "&.MuiButtonBase-root:hover .MuiButton-endIcon svg": {
          color: iconHoverColor,
        },
      }}
    >
      {btnText}
    </Button>
  );
};

export default GlobalButton;
